export default __webpack_public_path__ + "static/media/memory-matching-game.05c1fadc.svg";